// extracted by mini-css-extract-plugin
module.exports = {"text":"Sections_text__1BTTT","row":"Sections_row__23AlH","par":"Sections_par__RyF48"};